<div class="widgets-container" (window:resize)="onResize($event)">
  <ng-content></ng-content>
</div>
